export const API_VERSION = `api/v2`;
export const BASE_URL = process.env.REACT_APP_API_URL;
export const DISCORD_BASE_URL = 'https://discord.com/api/v9/';
